import { Link } from "react-router-dom";
import { t } from "../i18n/t";

/**
 * xmg-sec-opsdocs (P1). The site footer: the privacy policy and terms of use are reachable from every screen,
 * signed in or not (Xero developer platform T&Cs clause 9: "available to any user"). Mounted by `AuthLayout`
 * (sign-in, sign-up and every other anonymous screen), by the signed-in `RootLayout` and by the legal pages.
 */
export function LegalFooter(): JSX.Element {
  return (
    <footer className="legalfooter">
      <Link to="/privacy">{t("legal.privacy_link")}</Link>
      <span aria-hidden="true">·</span>
      <Link to="/terms">{t("legal.terms_link")}</Link>
    </footer>
  );
}
